import {IDataModel} from "../../services/IDataModel";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {IDataFilter} from "../../services/DataTable";
import * as _ from "lodash";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";
import {SalesNotesModel} from "./sales-notes.model";
import {SalesNotesType} from "./sales-notes.type";
import * as moment from "moment/moment";

@Injectable()
export class SalesNotesService{

    private API_ROOT:string = '/sales-notes';

    constructor(private http:Http) {
    }


    getListByPricing(pricingId:number, filter?:IDataFilter): Observable<ListResponseModel<SalesNotesModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }

        return this.http
            .get(`/pricings/${pricingId}/sales-notes`, new RequestOptions({
                search: params
            }))
            .map((res) => res.json());
    }

    saveListByPricing(pricingId:number, owners: SalesNotesModel[]): Observable<ListResponseModel<SalesNotesModel>> {
        return this.http.put(`/pricings/${pricingId}/sales-notes`, owners)
            .map((res) => {
                let response: ListResponseModel<SalesNotesModel> = res.json();
                return response;
            });
    }

    /**
     * Add custom notes from server to client notes
     */
    unionCollections (fromServer: SalesNotesModel[], fromClient: SalesNotesModel[]) : SalesNotesModel[] {
        let notes = [];

        let chooseBest = (note1:SalesNotesModel , note2:SalesNotesModel ) => {
            if (note1 && !note2) return note1;
            if (note2 && !note1) return note2;

            let date1 = moment(note1.updated_at || 0).unix();
            let date2 = moment(note2.updated_at || 0).unix();

            if (note1.id) note2.id = note1.id;
            if (note2.id) note1.id = note2.id;

            if (date2 > date1) {
                return note2;
            } else {
                return note1;
            }
        };
        
        for (let i in fromServer) {
            let salesNoteFromServer = fromServer[i];
            let salesNoteFromClient = _.find(fromClient, {key: salesNoteFromServer.key});

            let note = chooseBest(salesNoteFromClient, salesNoteFromServer);

            notes.push(note);
        }

        for (let i in fromClient) {
            let salesNoteFromClient = fromClient[i];
            let salesNoteFromVar = _.find(notes, {key: salesNoteFromClient.key});

            if (!salesNoteFromVar) {
                notes.push(salesNoteFromClient);
            }

        }

        return notes;
    };

}


// WEBPACK FOOTER //
// ./src/app/models/sales-notes/sales-notes.service.ts